module.exports = __webpack_public_path__ + "img/5.6bf23bf4.jpg";